<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Lead from '$lib/PageSections/Forms/Lead/Lead.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import freeShipingMerchandiseImg from './images/boxes.jpg';
	import freeShippingLabelImg from './images/freeShippingLabel.png';
</script>

<Section>
	<p style="text-wrap:balance;">
		Due to increased material and shipping costs, Indow will be updating its
		pricing model on January 1st, 2024. Shipping costs will no longer be
		included in the square foot pricing for standard, premium, or commercial
		inserts. While the cost of shipping varies by location and package size, the
		average shipping fee is approximately $300-$400 for most orders - but can be
		much higher.
	</p>
	<p style="text-wrap:balance;">
		Now is the perfect time to order your inserts before costs increase. Be sure
		to start your order<a
			href="#*"
			class="!text-indow-grey-dark no-underline"
			title="You must pay your initial deposit by 12/31/2023 to remain eligible for Free Shipping. Additional exclusions may apply - be sure to consult with your Fit Specialists about your order's eligibility."
		>
			<sup>*</sup>
		</a>
		by 12/31/2023 to take advantage of Free Shipping<a
			href="#**"
			class="!text-indow-grey-dark no-underline"
			title="Free Shipping available for the contiguous USA only. Shipments to Alaska, Hawaii, and Canada incur additional shipping charges. Orders for 1-2 panels incur additional shipping fees. Orders with at least one insert equal or greater to 16 sq ft are subject to a $199 Oversized Handling Fee, which is waived on orders over $1,500."
		>
			<sup>**</sup>
		</a>
		!
	</p>
	<Button href="/how-to/get-indow-inserts">GET STARTED</Button>
	<p class="text-left text-sm italic" id="*">
		<sup>*</sup>You must pay your initial deposit by 12/31/2023 to remain
		eligible for Free Shipping. Additional exclusions may apply - be sure to
		consult with your Fit Specialists about your order's eligibility.
	</p>
	<p class="text-left text-sm italic" id="**">
		<sup>**</sup>Free Shipping available for the contiguous USA only. Shipments
		to Alaska, Hawaii, and Canada incur additional shipping charges. Orders for
		1-2 panels incur additional shipping fees. Orders with at least one insert
		equal or greater to 16 sq ft are subject to a $199 Oversized Handling Fee,
		which is waived on orders over $1,500.
	</p>
</Section>

<Section
	imageColumn={freeShipingMerchandiseImg}
	columnPosition="left"
	backgroundColor="grey-dark"
	title="Save More With Tax Credits"
>
	<p style="text-wrap:balance;">
		Did you know? In addition to saving on shipping costs, you may also be
		eligible to save 30% on the cost of window inserts. With the Energy
		Efficient Home Improvement Tax Credit you could save up to $1,200 in tax
		credits on your 2024 tax bill!
	</p>
	<Button href="/window-insert-tax-savings">LEARN MORE</Button>
</Section>

<Section innerClass="!pt-0" class="!z-0">
	<div class="mb-16">
		<Parallax --translateY="10%">
			<Image src={freeShippingLabelImg} alt="Free Shipping" class="!w-3/4" />
		</Parallax>
	</div>
	<h2>Get Started Today</h2>
	<p>
		To learn how Indow can be your solution for window worries and how you can
		enjoy Free Shipping.
	</p>
	<Lead buttonText="CONTACT US" class="max-w-xl rounded-lg p-6 shadow-lg">
		{#snippet text()}
			<span></span>
		{/snippet}
	</Lead>
</Section>

<Reviews />
